import Vue from 'vue'
import Vuex from 'vuex'
import { DEFAULT_THEME, applyTheme } from './utils/theme'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    theme: localStorage.getItem('score-theme') || DEFAULT_THEME
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    },
    SET_THEME(state, theme) {
      state.theme = theme
      localStorage.setItem('score-theme', theme)
      applyTheme(theme)
    }
  },
  actions: {
    login({ commit }, data) {
      commit('SET_TOKEN', data.token)
      commit('SET_USER_INFO', { nickname: data.nickname, username: data.username })
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
})
